import { format } from 'date-fns';

const isValidISODateString = (str) => {
  const date = new Date(str);
  return !isNaN(date.getTime()) && date.toISOString() === str;
};

export const getStartOfDayUTC = (date) => {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d.toISOString();
};

export const getEndOfDayUTC = (date) => {
  const d = new Date(date);
  d.setHours(23, 59, 59, 999);
  return d.toISOString();
};

export const getDateRangeUTC = ({ startDate, endDate }) => ({
  from: getStartOfDayUTC(startDate),
  to: getEndOfDayUTC(endDate),
});

export const localDateTimeToUTC = (localDateTime) => {
  const date = new Date(localDateTime);
  return isNaN(date.getTime()) ? '' : date.toISOString();
};

export const formatUTCTimestampToLocal = (timestamp, formatStr) => {
  let date;

  if (!timestamp) return 'Invalid Date';

  if (typeof timestamp === 'string' && isValidISODateString(timestamp)) {
    date = new Date(timestamp);
  } else if (!isNaN(Number(timestamp))) {
    date = new Date(Number(timestamp) * 1000);
  } else {
    return 'Invalid Date';
  }

  return isNaN(date.getTime()) ? 'Invalid Date' : format(date, formatStr);
};
